import { Injectable } from "@angular/core";

import { Observable, of } from "rxjs";
import { map, switchMap } from "rxjs/operators";

import { InstallationHttpClient } from "@e-forsyning/common/http";

import { Rolle } from "../bruger";
import { AktuelBrugerObserver } from "../bruger/aktuel-bruger.observer";
import { Huskeliste } from "./huskeliste";
import { HuskelisteDbMapper } from "./huskeliste-db-mapper";

@Injectable({ providedIn: "root" })
export class HuskelisteRepository {
    constructor(private readonly http: InstallationHttpClient, private readonly aktuelBrugerObserver: AktuelBrugerObserver) {}

    public hentHuskelister(): Observable<Huskeliste[]> {
        return this.aktuelBrugerObserver.valueChanges.pipe(
            switchMap((bruger) => {
                const harAdgangTilHuskelister = !Rolle.erForbruger(bruger.rolle);
                if (!harAdgangTilHuskelister) {
                    return of([]);
                }

                return this.http
                    .get("api/getHuskeLister")
                    .pipe(map((result: any) => HuskelisteDbMapper.dbToHuskellister(result.huskelister)));
            })
        );
    }
}
